<div class="checklist-feedback" [class.checklist-feedback--embedded]="embedded">
	@if (!embedded) {
		<div class="checklist-feedback__standalone-header">
			<h2 class="checklist-feedback__standalone-title">Feedback</h2>
			<button type="button" class="aa-btn" data-variant="tertiary" (click)="goBack()">Back</button>
		</div>
	}

	@if (submitted) {
		@if (!embedded) {
			<p class="checklist-feedback__submitted-msg">Feedback submitted.</p>
		}
	} @else if (template) {
		@if (!embedded) {
			<p class="checklist-feedback__template-name">{{ template.name }}</p>
		}

		<form [formGroup]="form">
			<div formArrayName="answers" class="checklist-feedback__questions">
				@for (question of pagedQuestions; track question.id; let i = $index) {
					<div class="checklist-feedback__question" [formGroupName]="globalQuestionIndex(i)">
						<p class="checklist-feedback__question-no">Question {{ questionDisplayNumber(i) }}</p>
						<p class="checklist-feedback__prompt">{{ question.prompt }}</p>

						@if (needsRating(question)) {
							<div class="checklist-feedback__ratings">
								<span class="checklist-feedback__field-label">Rating</span>
								<app-feedback-rating-scale
									[selected]="answerGroup(globalQuestionIndex(i)).get('rating')?.value"
									(selectedChange)="answerGroup(globalQuestionIndex(i)).get('rating')?.setValue($event)"
								></app-feedback-rating-scale>
							</div>
						}

						@if (needsAnswer(question)) {
							<div class="checklist-feedback__comment">
								<label class="checklist-feedback__field-label" [for]="'feedback-comment-' + globalQuestionIndex(i)">
									Answer
									@if (answerRequired(question)) {
										<span class="checklist-feedback__required" aria-hidden="true">*</span>
									} @else {
										<span class="checklist-feedback__optional">(optional)</span>
									}
								</label>
								<textarea
									[id]="'feedback-comment-' + globalQuestionIndex(i)"
									class="checklist-feedback__comment-input"
									rows="3"
									placeholder="Add your answer here..."
									formControlName="remarks"
									[attr.aria-required]="answerRequired(question)"
								></textarea>
								@if (
									answerGroup(globalQuestionIndex(i)).get("remarks")?.invalid &&
									answerGroup(globalQuestionIndex(i)).get("remarks")?.touched
								) {
									<p class="checklist-feedback__field-error">This field is required.</p>
								}
							</div>
						}
					</div>
				}
			</div>

			@if (totalPages > 1) {
				<div class="checklist-feedback__pagination">
					<button
						type="button"
						class="checklist-feedback__pagination-btn"
						[disabled]="pageIndex === 0"
						aria-label="Previous page"
						(click)="prevPage()"
					>
						<span class="aa-mat-icon">chevron_left</span>
					</button>
					<span class="checklist-feedback__pagination-label">{{ pageIndex + 1 }}</span>
					<button
						type="button"
						class="checklist-feedback__pagination-btn"
						[disabled]="pageIndex >= totalPages - 1"
						aria-label="Next page"
						(click)="nextPage()"
					>
						<span class="aa-mat-icon">chevron_right</span>
					</button>
				</div>
			}

			@if (!embedded) {
				@if (submitError) {
					<p class="checklist-feedback__submit-error">{{ submitError }}</p>
				}
				<div class="checklist-feedback__submit-wrap">
					<button
						type="button"
						class="aa-btn"
						data-variant="primary"
						[disabled]="submitting || form.invalid"
						(click)="submitFeedback()"
					>
						Submit feedback
					</button>
				</div>
			}
		</form>
	} @else if (!embedded) {
		<p class="checklist-feedback__empty">No feedback questionnaire is available for this assessment.</p>
	}
</div>
